/**
 * Normalize a raw backend patient (getPatientByIdApi shape) into the
 * sessionStorage.patient payload shared by the chat flow (MyPatient-demo)
 * and the encounter-notes /order slash command.
 */
export function buildPatientSession(patient) {
  if (!patient) return null;

  const getContact = (type) => {
    const c = patient.patient_contact?.find(
      x => x.contact_description === type || x.contact_type === type,
    );
    return (c?.contact_details || '').replace(/[\x00-\x1F\x7F]/g, '').trim();
  };

  const address = patient.patient_address?.[0] || {};
  const id = patient.patient_id;
  const firstName = patient.patient_first_name || '';
  const lastName = patient.patient_last_name || '';

  // patientAge getter parses birthdate as MM/DD/YYYY
  const raw = patient.patient_birthdate || '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(raw);
  const birthdate = m ? `${m[2]}/${m[3]}/${m[1]}` : raw;

  return {
    id,
    patient_id: id,
    calendar_id: id,
    birthdate,
    first_name: firstName,
    last_name: lastName,
    full_name: `${firstName} ${lastName}`.trim(),
    gender: patient.patient_gender || '',
    email: getContact('email'),
    phone: getContact('phone'),
    country: address.country || '',
    state: address.state || '',
    zipcode: address.zipcode || '',
    city: address.city || '',
    streetAddress: address.street_address || '',
  };
}
